import { Inbox } from "lucide-react";
import PropTypes from "prop-types";
import { TEXT_LIBRARY } from "../../utils/constants";

function NoData({ height = "100%" }) {
  return (
    <div
      className="p-4 text-gray-600 flex"
      style={{ height: height, flexDirection: "column", justifyContent: "center", alignItems: "center" }}
    >
      <Inbox color="rgba(0, 0, 0, 0.25)" size={100} absoluteStrokeWidth={30} />
      <div>{TEXT_LIBRARY.NO_DATA_AVAILABLE}</div>
    </div>
  );
}

export default NoData;

NoData.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
